// Neo's headline in the header of every boat page (TOM-526), where the quick
// readings were: a dot in the status's tone, "Neo ·", and the headline from
// Neo's status (contract §5.20) on one line, cut with an ellipsis. It is a
// button that opens the chat: home's on home, the Neo panel elsewhere.
//
// On home it also carries the time Neo wrote it ("Neo · 8:11 AM · …"), and
// the status block under the header goes on from it with the body and the
// thing to watch. At 768 px and under, home's headline wraps (three lines at
// most) rather than being cut, so a phone shows all of it (TOM-526 follow-up).
//
// The tone dot is neutral for `unknown`, never calm's green (the boat gone
// quiet, or nothing to go on yet), as the status block on home draws it.

import type { NeoStatus } from '@neomaris/protocol';

import { composedTime } from '../../lib/useNeoStatus';

export function NeoHeadline({
  status,
  onOpen,
  home = false,
}: {
  /** Null until the status is read, or when it can't be: nothing is drawn. */
  status: NeoStatus | null;
  onOpen: () => void;
  /** Home's: with the time, and wrapped rather than cut at 768 px and under. */
  home?: boolean;
}) {
  if (status === null) return <span className="neo-headline neo-headline--empty" />;
  const time = home ? composedTime(status) : null;
  return (
    <button
      type="button"
      className={`neo-headline neo-headline--${status.tone}${home ? ' neo-headline--home' : ''}`}
      aria-label={
        time === null
          ? `Neo: ${status.headline} Open the chat`
          : `Neo at ${time}: ${status.headline} Open the chat`
      }
      title={status.headline}
      data-testid="neo-headline"
      data-tone={status.tone}
      onClick={onOpen}
    >
      <span className="neo-headline__dot" aria-hidden="true" />
      <span className="neo-headline__line" aria-hidden="true">
        <span className="neo-headline__who">
          Neo ·{' '}
          {time === null ? null : (
            <>
              <time dateTime={status.composedAt}>{time}</time> ·{' '}
            </>
          )}
        </span>
        <span className="neo-headline__text">{status.headline}</span>
      </span>
    </button>
  );
}
